import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppSettings } from './app.settings';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr} from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from './shared/shared.module';
import { LoadingService } from './core/services/loading.service';
import { AppInterceptor } from './core/interceptors/app-interceptor';
import { Overlay, OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './shared/utils/custom-overlay-container';
import { MAT_MENU_SCROLL_STRATEGY } from '@angular/material/menu';
import { menuScrollStrategy } from './shared/utils/scroll-strategy';
import { CoreModule } from './core/core.module';
import { CookieService } from 'ngx-cookie-service';
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import {provideTranslateService, TranslateModule} from "@ngx-translate/core";
import { TitleStrategy } from '@angular/router';
import { AppTitleStrategy } from './core/services/app-title.strategy';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AppRoutingModule,
    NgxSpinnerModule,
    SharedModule,
    CoreModule,
    BrowserAnimationsModule,
    TranslateModule
  ],
  providers: [
    [LoadingService, CookieService],
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    {
      provide: MAT_MENU_SCROLL_STRATEGY,
      useFactory: menuScrollStrategy,
      deps: [Overlay],
    },
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    AppSettings,
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'en'
    })
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
